module.exports = __webpack_public_path__ + "img/4.f0d1b7b6.png";